var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-ad"},[_c('h3',[_vm._v("LeetCode 1000道题目一道道讲解，最优解一题多解")]),_c('h4',[_vm._v("初学者即可一天10题，有经验者一天30题")]),_c('span',{staticClass:"btn",staticStyle:{"cursor":"pointer"}},[_vm._v("立即体验")])])
}]

export { render, staticRenderFns }